<template>
	<!-- 往期限免 -->
	<div class="wqxmBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="backUrl">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">往期限免</p>
				</div>
			</div>
		</van-sticky>
		<!-- 列表数据 -->
		<div>
			<div class="blockBox">
				<div class="blockLeft" v-for="(item,index) in bookInfoList" :key="index">
					<div class="book_Img" @click="jumpBookinfo(item.book_id)">
						<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
					</div>
					<div class="blockBookInfo">
						<div class="bookName" >
							<span class="bookTxtBox" v-if="item.name">
								<van-notice-bar scrollable :text="item.name"></van-notice-bar>
							</span>
							<span class="bookTxtBox" v-else>
								<van-notice-bar scrollable :text="item.name"></van-notice-bar>
							</span>
						</div>
						<div class="auther"><span @click="toZz(item.author_id)">{{item.author}}</span>
							<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p>
						</div>
						<p class="bookType">{{item.original_name}}-{{item.appetency_name}}-{{item.epoch_name}}-{{item.type_name}}</p>
						<!-- 简介：  -->
						<p class="introduction">{{item.introduce}}</p>
						<div class="book_button">
							<button v-for="i in item.lable_list">{{i.name}}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				bookInfoList: []
			}
		},
		created() {
			this.get_xianmian_old()
		},
		methods: {
			backUrl() {
				this.$router.push('/bookcity')
			},
			get_xianmian_old() {
				this.$axios.post(this.$api.xianmian_old).then(res => {
					console.log(res, '历史限免')
					if (res.status == 200) {
						this.bookInfoList = res.data.data
					}

				})
			},
			//读者专栏
			toDz(val) {
				this.$router.push({
					path: '/dzzhuanlan',
					query: {
						user_id: val
					}
				})
			},
			//作者专栏
			toZz(val) {
				this.$router.push({
					path: '/autherZl',
					query: {
						user_id: val
					}
				})
			},
			// 跳转详情页
			jumpBookinfo(val) {
			
				this.$router.push({
					path: '/bookinfo',
					query: {
						id: val,
						url: this.$route.query.url
					}
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.wqxmBox {

		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 70px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 90px;
				line-height: 90px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		//列表数据
		.blockBox {
			overflow: hidden;
			position: relative;
			padding: 0 16px;
			background-color: #fff;

			.blockLeft {
				display: flex;
				padding: 20px 0px;
				padding-bottom: 20px;
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.book_Img {
					// width: 138px;
					width: 175px;
					height: 260px;
					overflow: hidden;
					-webkit-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
					/*no*/
					-moz-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
					/*no*/
					box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
					/*no*/
					img {
						width: 175px;
						height: 260px;
						display: block;
						float: left;
						
					}
				}

				.blockBookInfo {
					margin-left: 20px;
					flex: 1;
					font-size: 26px;
					/*px*/
					line-height: 30px;

					.auther {
						color: #000;
						font-size: 26px;
						/*px*/
						opacity: 0.6;
						/*px*/
						p {
							display: inline-block;
							float: right;
							font-weight: 400;
						
							span {
								margin-left: 8px;
								color: #000;
								font-size: 26px;
								/*px*/
							}
						}
					}
					
					.bookName {
						// line-height: 40px;
						padding-bottom: 20px;
						font-size: 30px;
						/*px*/
						// font-weight: 600;
						.bookTxtBox {
							width: calc(100vw - 260px);
							font-size: 30px;
							/*px*/
							color: #000;
							overflow: hidden;
							display: inline-block;
							.van-swipe .van-swipe__track--vertical .van-swipe-item {
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
							}
						
							.van-notice-bar {
								background: rgba(0, 0, 0, 0);
								color: #000;
								height: 30px;
								padding: 0;
							}
						}
					}

					.bookType,
					.introduction {
						padding-top: 20px;
						color: #a3a3a3;
					}

					.introduction {
						width: 60vw;
						padding-top: 15px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}

					.book_button {
						margin-top: 25px;
						margin-bottom: 10px;
						button {
							border: 0;
							outline: none;
							border: 1px solid #fec6d5;
							/*no*/
							border-radius: 28px;
							padding: 0px 20px;
							display: inline-block;
							// height: 40px;/*px*/
							// line-height: 40px;/*px*/
							background-color: #fff8fa;
							color: #fa7298;
							margin-right: 20px;
							margin-bottom: 10px;
							font-size: 20px;
							/*px*/

						}

						.active {
							background-color: #fa7298;
							color: #ffffff;
						}
					}
				}
			}
			
			
			.blockLeft:last-child{
				margin-bottom: 60px;
			}
		}
	}
</style>
